import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from '../../../consts';
import { POSITION_CLOSURE_REASON } from '../../../consts/enums';
import STRING_KEYS from '../../../language/keys';
import { CloseStatusChip } from './CloseStatusChip';

type PositionCloseStatusProps = {
  closedAt: Date | string,
  closedByUserId: string,
  closureReason: string,
  closureReasonfreeText: string,
}
export const PositionCloseStatus = ({
  closedAt,
  closedByUserId,
  closureReason,
  closureReasonfreeText,
}:PositionCloseStatusProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const dateClosePosition = moment(closedAt).format(DATE_FORMAT.TABLE_LIST);

  const details = translate(STRING_KEYS.CLOSED_BY, {
    username: closedByUserId,
    date: dateClosePosition,
  });
  const reasonResponse = () => {
    switch (closureReason) {
      case POSITION_CLOSURE_REASON.OTHER:
        return closureReasonfreeText;
      case POSITION_CLOSURE_REASON.POSITION_CANCELED:
        return translate(STRING_KEYS.POSITION_CANCELED);
      case POSITION_CLOSURE_REASON.POSITION_ALREADY_FULFILLED:
        return translate(STRING_KEYS.POSITION_ALREADY_FULFILLED);
      default:
        return '';
    }
  };

  const reason = reasonResponse();

  return (
    <CloseStatusChip
      details={ details }
      label={ translate(STRING_KEYS.CLOSED) }
      reason={ reason }
    />
  );
};
